module.exports = __webpack_public_path__ + "static/media/aws.fdff4014.svg";